import HomeBanner from '../components/homeBanner/homeBanner';
import KtempleNav from '../components/ktempleNav/ktempleNav';
import KContact from "../components/kcontact/kcontact";
import Footer from '../components/Footer/Footer';
import VisitingTemple from '../components/VisitingTemple/VisitingTemple';
import CommonEvent from "../components/kcommonevent/kcommonevent";
import DocumentMeta from 'react-document-meta';


function Templecontact() {
 const meta = {
    title: "Contact Us - Radha Madhav Krishna Temple Milwaukee",
    description: "Get in touch with us for any inquiries or assistance regarding the Radha Madhav Krishna Temple in Milwaukee. We are here to help you.",
    keywords: "Contact, Radha Madhav Krishna Temple, Milwaukee, inquiries, assistance"
  };
  return (
    <div>
      <DocumentMeta {...meta} />
      <KtempleNav />
      <HomeBanner />
      <KContact />
      <CommonEvent />
      <VisitingTemple />
      <Footer />
    </div>
  )
}

export default Templecontact